import type { AssessmentBodyRef, CourseDetailsData, CourseListApiItem } from "../types";

export function collectAssessmentBodiesFromCoursePayload(
	course?: CourseListApiItem | CourseDetailsData | null,
): AssessmentBodyRef[] {
	if (!course) return [];

	const collected: AssessmentBodyRef[] = [];
	const seen = new Set<string>();

	const push = (body?: Partial<AssessmentBodyRef> | null) => {
		const uuid = body?.uuid?.trim();
		if (!uuid || seen.has(uuid)) return;
		seen.add(uuid);
		collected.push({
			uuid,
			name: body?.name?.trim() || uuid,
			identifier: body?.identifier,
			id: body?.id,
			isActive: body?.isActive,
		});
	};

	(course.assessmentBodies ?? []).forEach(body => push(body));

	const rawIds = (course as CourseListApiItem).assessmentBodyIds;
	if (Array.isArray(rawIds)) {
		rawIds.forEach(id => {
			if (typeof id === "string") push({ uuid: id, name: id });
		});
	}

	return collected;
}
